import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [

  {
    path: '/',
    name: 'index',

    component: () => import('../views/Index.vue'),
    meta: {
      title: '江苏博骄工程机械有限公司—首页'
    }
  },
  {
    path: '/login',
    name: 'login',

    component: () => import('../views/login.vue'),
    meta: {
      title: '江苏博骄工程机械有限公司—登录'
    }
  },
  {
    path: '/look',
    name: 'look',

    component: () => import('../views/look.vue'),
    meta: {
      title: '江苏博骄工程机械有限公司—走进博骄'
    }
  },
  {
    path: '/news',
    name: 'news',

    component: () => import('../views/news.vue'),
    meta: {
      title: '江苏博骄工程机械有限公司—新闻列表'
    }
  },
  {
    path: '/productions',
    name: 'productions',

    component: () => import('../views/productions.vue'),
    meta: {
      title: '江苏博骄工程机械有限公司—产品中心'
    }
  },
  {
    path: '/partner',
    name: 'partner',

    component: () => import('../views/partner.vue'),
    meta: {
      title: '江苏博骄工程机械有限公司—合作伙伴'
    }
  },
  {
    path: '/server',
    name: 'server',

    component: () => import('../views/server.vue'),
    meta: {
      title: '江苏博骄工程机械有限公司—售后服务'
    }
  }
]

const router = new VueRouter({

  routes
})

export default router
